import EditIcon from '@mui/icons-material/Edit';
import React from 'react';

import { Location } from '_lib/api/apiTypes.shim';

import { Box } from '_lib/components/Box/Box';
import { Grid } from '_lib/components/Grid/Grid';
import { IconButton } from '_lib/components/IconButton/IconButton';
import { List } from '_lib/components/List/List';
import { ListItem } from '_lib/components/ListItem/ListItem';
import { ListItemButton } from '_lib/components/ListItemButton/ListItemButton';
import { Tooltip } from '_lib/components/Tooltip/Tooltip';
import { Typography } from '_lib/components/Typography/Typography';
import { formatAddressOneLine } from '_lib/utils/helpers';

export interface LocationListProps {
  locationList?: Location[];
  selectedLocation?: Location;
  onLocationClicked?: (location: Location) => void;
  onLocationEdit?: (location: Location) => void;
}

export const LocationList = (props: LocationListProps): React.ReactElement => {
  const { locationList, selectedLocation, onLocationEdit, onLocationClicked } = props;

  return (
    <Box>
      <List>
        {locationList?.map((location) => (
          <ListItem
            key={location.providerId}
            secondaryAction={
              !!onLocationEdit && (
                <Tooltip title='Edit' placement='left'>
                  <IconButton onClick={() => onLocationEdit(location)}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              )
            }>
            <ListItemButton
              onClick={() => (onLocationClicked ? onLocationClicked(location) : {})}
              selected={location.providerId === selectedLocation?.providerId}
              data-testid={'location-list-item'}>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={12}>
                  <Typography variant='body1Bold' text={location.name} />
                </Grid>
                <Grid item xs={6} sm={12}>
                  <Typography text={formatAddressOneLine(location)} />
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
